module.exports = __webpack_public_path__ + "img/roblox-default.e2bcf988.webp";